<div class="d-flex mt-2 row">
  <div class="col-md-12 text-end">
    <button mat-button color="warn" (click)="Close()">Close</button>
  </div>
  <h1 class="text-center mb-4"> Daily Child Occupancy </h1>
  <h2>Center: {{ getCentreNameByCode() }}</h2>
  <h2>Date: {{ selectedDate | date: 'dd/MM/yyyy' }}</h2>
  <mat-card class="col-md-12 col-sm-12 mb-4">
    <table mat-table [dataSource]="dataSource" class="child-table">
      <ng-container matColumnDef="srNo">
        <th mat-header-cell *matHeaderCellDef> Sr. No.</th>
        <td mat-cell *matCellDef="let i = index"> {{ i + 1 }}</td>
      </ng-container>

      <ng-container matColumnDef="childName">
        <th mat-header-cell *matHeaderCellDef> Child Name</th>
        <td mat-cell *matCellDef="let child"> {{ child.firstName }} {{ child.lastName }}</td>
      </ng-container>

      <ng-container matColumnDef="childCode">
        <th mat-header-cell *matHeaderCellDef> Child Code</th>
        <td mat-cell *matCellDef="let child"> {{ child.childCode }}</td>
      </ng-container>

      <ng-container matColumnDef="currentUnit">
        <th mat-header-cell *matHeaderCellDef> Child Unit</th>
        <td mat-cell *matCellDef="let child"> {{ child.currentUnit }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </mat-card>
</div>

